import { type AxiosRequestConfig } from 'axios'

const getUserOtherInfo = (id?: string): AxiosRequestConfig => {
  return {
    method: 'GET',
    url: id ? `/users/${id}/info/other` : '/user/info/other'
  }
}

export { getUserOtherInfo }
